// src/pages/Servicos.jsx

import Servicos from "../components/sections/Services/Servicos";

import { servicos } from "../components/utils/servicos";

import "../Styles/cartao.css";
import "../Styles/servicos.css";

export default function ServicosPage() {
  return (
    <div className="servicos-page">
      <Servicos items={servicos} />
    </div>
  );
}